// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XCV7F","navRight":"Nav_navRight__x1Xtf"};